<template>
  <div>
    <b-tabs v-model="activeTab" justified nav-class="nav-tabs-main" content-class="p-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none ">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block title">{{ $t("asset-group.organization") }}</span>
        </template>
        <div class="card rounded p-4" v-if="activeTab == 0">
          <span class="title mt-1 ">{{ $t("asset-group.organization") }}</span>

          <AssetGroupCategoryBoxes product="DDO" />
          <AssetGroupBoxes product="DDO" />
        </div>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block title">
            <span>{{ $t("asset-group.list-view") }} </span>
          </span>
        </template>
        <DdoAssetGroupCategoryAssetGroupInventoryListView v-if="activeTab == 1" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block title">
            <span>{{ $t("asset-group.degree-of-criticality") }} </span>
          </span>
        </template>
        <DdoAssetGroupCategoryAssetGroupCriticalityView v-if="activeTab == 2" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AssetGroupBoxes from "./component/asset-group-boxes.vue";
import AssetGroupCategoryBoxes from "./component/asset-group-category-boxes.vue";

import DdoAssetGroupCategoryAssetGroupCriticalityView from "../asset-group-inventory/ddo-asset-group-category-asset-group-criticality-view.vue";
import DdoAssetGroupCategoryAssetGroupInventoryListView from "../asset-group-inventory/ddo-asset-group-category-asset-group-inventory-list-view.vue";

export default {
  components: {
    AssetGroupCategoryBoxes,
    AssetGroupBoxes,
    DdoAssetGroupCategoryAssetGroupInventoryListView,
    DdoAssetGroupCategoryAssetGroupCriticalityView,
  },

  beforeDestroy() {
    //this.$store.commit("assetGroupBoxes/clear");
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    redirectToAssetGroupListView() {
      this.$router.push("/organization/asset-group-inventory/asset-groups");
    },
    redirectToInventory() {
      this.$router.push("/organization/asset-groups/inventory");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
